import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { ChevronRight } from 'lucide-react';

import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Select } from '@/components/ui/select';
import { Button } from '@/components/ui/button';

import SelectOfferingCategory from '@/app/offeringCategory/SelectOfferingCategory';

import { basicInfoSchema } from '../../_validator';

const BasicInfoForm = ({ initialValues, onHandleSubmit }) => {
  const form = useForm({
    resolver: zodResolver(basicInfoSchema),
    defaultValues: { ...initialValues }
  });

  const onSubmit = (values) => {
    onHandleSubmit(values);
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="space-y-4">
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Offering Name</FormLabel>
                <FormControl>
                  <Input placeholder="Enter offering name" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="description"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Description</FormLabel>
                <FormControl>
                  <Textarea placeholder="Describe your offering" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="categoryId"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Category</FormLabel>
                <Select
                  onValueChange={field.onChange}
                  defaultValue={field.value}
                >
                  <FormControl>
                    <SelectOfferingCategory
                      value={field.value}
                      onChange={field.onChange}
                    />
                  </FormControl>
                </Select>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <div className="flex justify-end pt-8">
          <Button type="submit" className="gap-1">
            Next
            <ChevronRight />
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default BasicInfoForm;
